export const beautifyDate = (date) => {
    const myDate = new Date();
    let beautifiedDate = '';
    if (date !== null && date !== undefined) {
        try {
            myDate.setFullYear(date.split('-')[2]);
            myDate.setMonth(date.split('-')[1] - 1);
            myDate.setDate(date.split('-')[0]);
            beautifiedDate = Intl.DateTimeFormat('en-US', { year: 'numeric', month: 'short', day: '2-digit' }).format(myDate);
        }
        catch (e) {
            beautifiedDate='';
        }
    }
    return (beautifiedDate);
};

// Converts the human readable dates the API returns ("17th Jan. 2022") into
// ISO-8601 ("2022-01-17"). Returns undefined for anything unparseable rather
// than guessing at a date.
export const toIsoDate = (date) => {
	if (!date) return undefined;
	const cleaned = String(date)
		.replace(/(\d+)(st|nd|rd|th)/i, '$1')
		.replace(/\./g, '');
	const parsed = new Date(cleaned);
	if (Number.isNaN(parsed.getTime())) return undefined;
	// Read the local parts rather than using toISOString(): the date is parsed
	// at local midnight, which UTC would roll back a day east of Greenwich.
	const month = String(parsed.getMonth() + 1).padStart(2, '0');
	const day = String(parsed.getDate()).padStart(2, '0');
	return `${parsed.getFullYear()}-${month}-${day}`;
};
